<template>
	<header :class="type">
		<slot>
			<hero-image :item="headingImage" />
		</slot>
	</header>
</template>

<script setup>
defineProps({
	headingImage: {
		type: Object,
		default: () => ({
			imageWebp: '',
			image: '',
			imageAlt: '',
			imagePortrait: '',
			imagePortraitWebp: '',
			imagePortraitAlt: '',
		}),
	},
	type: {
		type: String,
		default: 'small',
	},
	title: { type: String, default: '' },
	content: { type: String, default: '' },
	openinghoursLeft: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
header {
	position: relative;
	z-index: 1;
	padding: 0;

	&.large {
		width: 100%;
		height: 100vh;
	}

	&.fixed {
		position: absolute;
		inset: 0;
		z-index: 1;
	}

	&.small {
		height: 75vh;
	}
}
</style>
